const uaDetector = {
  isAndroid: (userAgent) => /Android/i.test(userAgent),
  isIos: (userAgent) => /iPhone|iPad|iPod/i.test(userAgent),
  isWindows: (userAgent) => /WPDesktop|Windows Phone|IEMobile/i.test(userAgent),
  isMobile: (userAgent) => (
    uaDetector.isAndroid(userAgent) || uaDetector.isIos(userAgent) || uaDetector.isWindows(userAgent)
  ),
};

export default uaDetector;
